import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React, { Component } from 'react';
import { format } from 'date-fns';
export default class Chart_garmin_sleep extends Component {
    constructor(props) {
        super(props);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.data !== this.props.data) {
            this.componentDidMount();
        }
    }
    componentDidMount() {
        var ctx = document.getElementById('Chart_garmin_sleep').getContext('2d');
        const deep_data = this.props.data[17]['value'];
        const light_data = this.props.data[18]['value'];
        const rem_data = this.props.data[19]['value'];
        const wake_data = this.props.data[20]['value'];
        const date = this.props.data[18]['time'];
        var x_wake = [];
        var x_light = [];
        var x_rem = [];
        var x_deep = [];
        var y_data = [];
        for (var i = 0; i < light_data.length; i++) {
            x_wake.push(deep_data[i]);
            x_light.push(light_data[i]);
            x_rem.push(rem_data[i]);
            x_deep.push(wake_data[i]);
            var tmp = format(new Date(date[i]), "yyyy/MM/dd");
            y_data.push(tmp);
        }
        var isstepped = false;
        if (window.Chart_garmin_sleep instanceof Chart) window.Chart_garmin_sleep.destroy();
        window.Chart_garmin_sleep = new Chart(ctx, {
            type: "bar",
            data: {
                //Bring in data
                labels: y_data,
                datasets: [
                    {
                        label: 'Deep (seconds)',
                        data: x_deep,
                        backgroundColor: '#303956',
                        datalabels: {
                            //     color: '#000000',
                            //     anchor: 'center',
                            //     align: 'center',
                            //     formatter: Math.round,
                            //     font: {
                            //         weight: 'bold'
                            //     }
                            display: false
                        }
                    },
                    {
                        label: 'Light (seconds)',
                        data: x_light,
                        backgroundColor: '#37718E',
                        datalabels: {
                            //     color: '#000000',
                            //     anchor: 'center',
                            //     align: 'center',
                            //     formatter: Math.round,
                            //     font: {
                            //         weight: 'bold'
                            //     }
                            display: false
                        }
                    },
                    {
                        label: 'REM (seconds)',
                        data: x_rem,
                        backgroundColor: '#A0ADA8',
                        datalabels: {
                            //     color: '#000000',
                            //     anchor: 'center',
                            //     align: 'center',
                            //     formatter: Math.round,
                            //     font: {
                            //         weight: 'bold'
                            //     }
                            display: false
                        }
                    },
                    {
                        label: 'Wake (seconds)',
                        data: x_wake,
                        backgroundColor: '#D60000',
                        datalabels: {
                            //     color: '#000000',
                            //     anchor: 'center',
                            //     align: 'center',
                            //     formatter: Math.round,
                            //     font: {
                            //         weight: 'bold'
                            //     }
                            display: false
                        }
                    }
                ]
            },
            options: {
                //Customize chart options
                responsive: true,
                legend: {
                    align: 'center',
                    labels: {
                        padding: 5
                    },
                },
                scales: {
                    xAxes: [{
                        type: 'time',
                        stacked: true,
                        offset: true,
                        time: {
                            unit: 'day'
                        }
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                },
                title: {
                    display: true,
                    text: "Daily Sleep Times",
                    fontSize: 30,
                    fontFamily: 'Noto Sans CJK TC'
                }
            }
        });
    }
    render() {
        return (
            <div>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.9.4/Chart.js"></script>
                <canvas id="Chart_garmin_sleep"></canvas>
            </div>
        );
    }
}